import { Routes, Route } from 'react-router-dom';
import { CarrierControlIndex } from './index';
import { ConsignmentsListPage } from './consignments/ConsignmentsListPage';
import { ConsignmentDetailPage } from './consignments/ConsignmentDetailPage';
import { FallbackRatesPage } from './fallback-rates/FallbackRatesPage';
import { TntSettingsPage } from './tnt-settings/TntSettingsPage';
import { TrackingLogPage } from './tracking-log/TrackingLogPage';
import { WebhookLogPage } from './tracking-log/WebhookLogPage';
import { CarrierServicePage } from './carrier-service/CarrierServicePage';
import { ShippingRatesPage } from './shipping-rates/ShippingRatesPage';

export function CarrierControlRoutes(): JSX.Element {
  return (
    <Routes>
      <Route index element={<CarrierControlIndex />} />
      <Route path="consignments" element={<ConsignmentsListPage />} />
      <Route path="consignments/:id" element={<ConsignmentDetailPage />} />
      <Route path="shipping-rates" element={<ShippingRatesPage />} />
      <Route path="fallback-rates" element={<FallbackRatesPage />} />
      <Route path="tnt-settings" element={<TntSettingsPage />} />
      <Route path="tracking-log" element={<TrackingLogPage />} />
      <Route path="webhook-log" element={<WebhookLogPage />} />
      <Route path="carrier-service" element={<CarrierServicePage />} />
    </Routes>
  );
}
